import { useCancelConfigurationStateChange } from './useCancelConfigurationStateChange';
import { useConfigurationState } from './useConfigurationState';
import { useSetConfigurationState } from './useSetConfigurationState';

function getEnabledValue(code) {
  switch (code) {
    case 'TrackingEnabled':
      return true;
    case 'TrackingDisabled':
      return false;
    default:
      return null;
  }
}

export function useTrackingConfiguration(imei) {
  const {
    query: { data: state, refetch: refresh },
  } = useConfigurationState(imei, 'tracking');
  const { mutate: setState } = useSetConfigurationState(imei, 'tracking');
  const { mutate: cancel } = useCancelConfigurationStateChange(
    imei,
    'tracking',
  );

  function toggle(enabled) {
    setState({ State: enabled ? 'TrackingEnabled' : 'TrackingDisabled' });
  }

  return {
    isEnabled: getEnabledValue(state?.CurrentState),
    isPending: state?.IsPending,
    toggle,
    refresh,
    cancel,
  };
}
